import type { MealOptimisation } from 'lib/ogdb/types';
import { Container } from '..';
import styles from './FoodOptimizationSection.module.css';

const cx = (...args: Array<string | false | undefined | null>) =>
  args.filter(Boolean).join(' ');

export const FoodOptimizationSection = ({
  className,
  data,
}: {
  className?: string;
  data: MealOptimisation | null;
}) => {
  if (!data) {
    return <div className={styles.placeholder} aria-hidden="true" />;
  }

  return (
    <section className={cx(styles.root, className)}>
      <Container>
        <div className={styles.content}>
          {data.title ? <h3>{data.title}</h3> : null}

          <div className={styles.optimizationContent}>
            {data.items.map((item, i) => (
              <div key={i} className={styles.optimizationElement}>
                {item.title ? <h4>{item.title}</h4> : null}
                {item.description ? <p>{item.description}</p> : null}
              </div>
            ))}
          </div>

          {data.disclaimerText ? (
            <p className={styles.disclaimer}>
              {data.disclaimerTitle ? <b>{data.disclaimerTitle}. </b> : null}
              {data.disclaimerText}
            </p>
          ) : null}
        </div>
      </Container>
    </section>
  );
};
